module.exports = __webpack_public_path__ + "static/media/toyota-plus.bbceb81a.svg";